import {REFERRAL_REQUEST} from 'actions/auth/constants'
import * as action from 'actions'
import * as actionNotif from 'actions/notifications'
import * as actionAuth from 'actions/auth'
import * as apiAuth from 'api/auth'
import {take, call, put, fork} from 'redux-saga/effects'

export function * referralFlow () {
  while (true) {
    let request = yield take(REFERRAL_REQUEST)
    yield put(action.showProgressBar())
    yield put(action.sendingRequest(true))

    const {referral} = request.payload
    try {
      let response = yield call(apiAuth.referral, referral)
      yield put(actionAuth.changeReferralData(response.data))
    } catch (error) {
      yield put(actionNotif.error(error.message))
    } finally {
      yield put(action.sendingRequest(false))
      yield put(action.hideProgressBar())
    }
  }
}

export default function * authSaga () {
  yield fork(referralFlow)
}



// WEBPACK FOOTER //
// ./app/sagas/auth.js